/**
 * Where to send the user after signing in. The page they asked for travels as
 * `/login?next=<path>` (set by the route guard and by the 401 handler), so a
 * reload, a deep link or an expired session returns to that page instead of
 * the dashboard. Only same-app paths are accepted (no `//host` or `scheme:`).
 */
export const LOGIN_NEXT_PARAM = 'next';

export function loginPathFor(path: string): string {
  if (!path || path === '/' || path.startsWith('/login')) return '/login';
  return `/login?${LOGIN_NEXT_PARAM}=${encodeURIComponent(path)}`;
}

export function safeNextPath(search: string): string | null {
  const next = new URLSearchParams(search).get(LOGIN_NEXT_PARAM);
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\') || next.startsWith('/login')) {
    return null;
  }
  return next;
}
